import { useRouter } from '@tanstack/react-router';
import { ConnectorRouteView, JourneysConnectorHandoff, useConnectorHandoffHrefs } from '@/features/integrations';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import MParticleConnectorPage from './index.page';

/** The two spellings of this connector's URL. */
function useHandoffHrefs() {
  const router = useRouter();
  return useConnectorHandoffHrefs({
    buildMigrated: (workspaceId) =>
      router.buildLocation({ to: '/workspaces/$workspaceId/integrations/mparticle_out', params: { workspaceId } }).href,
    buildLegacy: (workspaceId) =>
      router.buildLocation({
        to: '/workspaces/$workspaceId/journeys/integrations/mparticle_out',
        params: { workspaceId },
      }).href,
  });
}

/** The old `/journeys/integrations/mparticle_out` URL. */
export function JourneysMParticleHandoff() {
  const { migrated } = useHandoffHrefs();

  return <JourneysConnectorHandoff isMigrated migratedHref={migrated} />;
}

/**
 * The migrated `/integrations/mparticle_out` URL.
 *
 * `ConnectorRouteView` applies the gates Ember's `integrations` root route applied. This page's own
 * route added no further permission gate — the mParticle permission gates the controls, not the
 * page — so nothing nests inside it here.
 */
export function MParticleConnectorRouteView() {
  const { legacy } = useHandoffHrefs();

  return (
    <ConnectorRouteView isMigrated legacyHref={legacy}>
      {(workspaceId) => (
        <RumPageRendered>
          <MParticleConnectorPage workspaceId={workspaceId} />
        </RumPageRendered>
      )}
    </ConnectorRouteView>
  );
}
